<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      active: item.path == $route.path,
      disabled: item.disabled,
    }"
    @click="getMenuListMBK(item.title)"
  >
    <b-link v-bind="linkProps" class="d-flex align-items-center">
      <component
        v-if="item.customIcon"
        :is="item.customIcon"
        class="nav-bar-icon-color"
      />
      <feather-icon v-else :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ item.title }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
  import { useUtils as useAclUtils } from '@core/libs/acl';
  import { BLink, BBadge } from 'bootstrap-vue';
  import { useUtils as useI18nUtils } from '@core/libs/i18n';
  import useVerticalNavMenuLink from './useVerticalNavMenuLink';
  import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink';

  // const CustomerSVG = () => import('@/@core/components/svg/nav-bar/Customer.vue');
  // const ProductSvg = () => import('@/@core/components/svg/nav-bar/Product.vue');
  // const PrivilegeSVG = () => import('@/@core/components/svg/nav-bar/Privileges.vue');
  // const ReportSvg = () => import('@/@core/components/svg/nav-bar/Report.vue');
  const NavArrowSvg = () => import('@/@core/components/svg/nav-bar/NavArrow.vue');
  // const BannerSVG = () => import('@/@core/components/svg/nav-bar/Banner.vue');
  // const DataManageSVG = () => import('@/@core/components/svg/nav-bar/IconDataManagement.vue');
  // const HoroscopedSVG = () => import('@/@core/components/svg/nav-bar/HoroScope.vue');
  // const MissionSVG = () => import('@/@core/components/svg/nav-bar/Mission.vue');
  // const ArticleSVG = () => import('@/@core/components/svg/nav-bar/Article.vue');
  // const Survey = () => import('@/@core/components/svg/nav-bar/Survey.vue');
  // const TagSVG = () => import('@/@core/components/svg/nav-bar/IconTags.vue');
  // const FriendSVG = () => import('@/@core/components/svg/nav-bar/IconFriends.vue');
  // const LotterySVG = () => import('@/@core/components/svg/nav-bar/IconLottery.vue');
  // const UserSVG = () => import('@core/components/svg/icon-navigation-bar/User.vue');
  // const CRMSVG = () => import('@core/components/svg/icon-navigation-bar/CRM.vue');
  // const PdpaSVG = () => import('@core/components/svg/icon-navigation-bar/IconPdpa.vue');
  // const FulfillmentSVG = () => import('@/@core/components/svg/nav-bar/Fulfillment.vue');
  // const DocumentSVG = () => import('@/@core/components/svg/nav-bar/Document.vue');
  // const ReportSVG = () => import('@/@core/components/svg/nav-bar/IconReport.vue');
  // const InventorySVG = () => import('@/@core/components/svg/nav-bar/Inventory.vue');
  // const CustomSVG = () => import('@/@core/components/svg/nav-bar/Mission.vue');
  // const FlashDealSVG = () => import('@/@core/components/svg/nav-bar/NavFlashDeal.vue');

  export default {
    components: {
      BLink,
      BBadge,
      
      //icon
      // CustomerSVG,
      // ProductSvg,
      // InventorySVG,
      // PrivilegeSVG,
      // ReportSvg,
      NavArrowSvg,
      // BannerSVG,
      // DataManageSVG,
      // HoroscopedSVG,
      // MissionSVG,
      // ArticleSVG,
      // Survey,
      // TagSVG,
      // FriendSVG,
      // LotterySVG,
      // UserSVG,
      // CRMSVG,
      // PdpaSVG,
      // FulfillmentSVG,
      // DocumentSVG,
      // ReportSVG,
      // CustomSVG,
      // FlashDealSVG,
    },
    mixins: [mixinVerticalNavMenuLink],
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    watch: {
      $route(to, from) {
        if (this.item.path == this.$route.fullPath)
          this.$store.commit(
            'horizontalMenu/SET_BREADCRUMB_LIST',
            this.item.breadcrumb
          );
      },
    },
    beforeMount() {
      if (this.item.path == this.$route.fullPath) {
        this.$store.commit(
          'horizontalMenu/SET_BREADCRUMB_LIST',
          this.item.breadcrumb
        );
      }
    },
    setup(props) {
      const { isActive, linkProps, updateIsActive, getMenuListMBK } = useVerticalNavMenuLink(
        props.item
      );
      const { t } = useI18nUtils();
      const { canViewVerticalNavMenuLink } = useAclUtils();
      return {
        isActive,
        linkProps,
        updateIsActive,
        // ACL
        canViewVerticalNavMenuLink,

        // i18n
        t,

        getMenuListMBK,
      };
    },
  };
</script>

<style scoped>
  @import '~@/assets/css/override-styles/vertical-navbar.css';
</style>
